import { I as Icon, _ as __assign } from './loadable.esm-a015de77.js';
import React__default from 'react';
import 'styled-components';

var RoundDeleteIcon = function (props) { return (React__default.createElement(Icon, __assign({}, props, { viewBox: "0 0 17 16" }),
    React__default.createElement("path", { d: "M11.85 5.879l-1.415-1.415-2.121 2.122-2.122-2.122L4.778 5.88 6.9 8l-2.12 2.121 1.413 1.415 2.122-2.122 2.121 2.122 1.414-1.415L9.728 8l2.121-2.121z" }),
    React__default.createElement("path", { d: "M13.97 2.343c-3.11-3.111-8.202-3.111-11.313 0-3.111 3.111-3.111 8.203 0 11.314 3.111 3.111 8.202 3.111 11.314 0 3.11-3.111 3.11-8.203 0-11.314zm-9.899 9.9c-2.333-2.334-2.333-6.152 0-8.486 2.334-2.333 6.152-2.333 8.485 0 2.334 2.334 2.334 6.152 0 8.486-2.333 2.333-6.151 2.333-8.485 0z" }))); };

var RoundDeleteIcon$1 = RoundDeleteIcon;

export { RoundDeleteIcon$1 as default };
//# sourceMappingURL=RoundDeleteIcon-d44f346e.js.map
